import { useLocation, useParams, Outlet } from "react-router-dom"
import { useAppSelector } from "../../state/hooks"
import { useRoute } from "@hydrologiq/shared/providers/helpers/useRoute"
import { getOrders } from "../../state/slice/ordersSlice"
import { routing } from "./routing"
import { pages } from "./pages"
import Selection, { SelectionItem, SubNavItem } from "@hydrologiq/shared/selection/Selection"
import { useGetCopyHomeRoute } from "@hydrologiq/shared/providers/helpers/useCopy"
import { useGetFeature } from "@hydrologiq/shared/providers/helpers/useFeature"

function OrderSelection({ children }: { children?: React.ReactNode }) {
  const { orderId } = useParams()
  const route = useRoute()
  let location = useLocation().pathname

  const orders = useAppSelector(getOrders)
  const order = orders?.find((order) => order.id === orderId)

  const activityless = useGetFeature("orders_activityless")
  const sectionPages = pages(location, orderId !== undefined, activityless)

  // Create sub-navigation items from sectionPages
  const subNavItems: SubNavItem[] = Object.entries(sectionPages.pages).map(([key, value]) => ({
    name: value,
    href: routing(route, location, orderId, false, key),
    disabled: false,
  }))

  // Hide nav when there's only one item
  const visibleSubNavItems = subNavItems.length > 1 ? subNavItems : []

  // Create parents for breadcrumb navigation
  const parents: SelectionItem[] = []

  const { name, path } = useGetCopyHomeRoute()

  const itemFromSubNav = subNavItems.find((subNavItem) => subNavItem.href === location)
  const item = order
    ? { id: order.id, name: order.name }
    : itemFromSubNav
    ? { id: itemFromSubNav.name, name: itemFromSubNav.name }
    : undefined

  return (
    <Selection
      sectionHeading={name}
      sectionBase={path}
      item={order ? { id: order.id, name: order.name } : item}
      parents={parents}
      subNavItems={visibleSubNavItems}
      subNavHome={sectionPages.defaultPage}
    >
      {children || <Outlet />}
    </Selection>
  )
}

export default OrderSelection
